import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreProformaProjectFormsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-proforma-project-forms',
	path: '/jira/core/projects/:projectKey/settings/forms',
	exact: true,
};
